import type { SiteWizard } from "../../../utils/backend-types";

export enum AssignmentType {
  Configuration = "Konfiguration",
  MeteringConcept = "Messkonzept & Zählerkonfiguration",
  Regulatory = "Regulatorische Daten",
  Contracts = "Ersten Vertrag anlegen",
  Vollmachten = "Vollmachten bereitstellen",
  Invoices = "Verträge & Lieferungen",
  OptiNode = "Prüfung durch Mitarbeiter:innen",

  VollmachtMsb = "Vollmacht Msb",
  VollmachtVermarkter = "Vollmacht Vermarkter",
  P6Contracts = "Paragraph 6 Verträge",
  VermarktungContracts = "Vermarktungsverträge"
}

export type OnboardingPhaseConfig = {
  displayPhase: (wizard: SiteWizard) => boolean;
  done: (wizard: SiteWizard) => boolean;
};

export const ONBOARDING_PHASES = new Map<AssignmentType, OnboardingPhaseConfig>(
  [
    // this is an ordered map to find the next phase to be done
    [
      AssignmentType.Configuration,
      {
        displayPhase: () => true,
        done: (wizard) => wizard.phases.configuration.done
      }
    ],
    [
      AssignmentType.MeteringConcept,
      {
        displayPhase: (wizard) => wizard.phases.meteringConcept.displayPhase,
        done: (wizard) => wizard.phases.meteringConcept.done
      }
    ],
    [
      AssignmentType.Regulatory,
      {
        displayPhase: () => true,
        done: (wizard) => wizard.phases.regulatory.done
      }
    ],
    [
      AssignmentType.Contracts,
      {
        displayPhase: (wizard) =>
          wizard.phases.p6Contracts?.displayPhase ||
          wizard.phases.vermarktungContracts?.displayPhase,
        done: (wizard) =>
          (!wizard.phases.p6Contracts?.displayPhase ||
            wizard.phases.p6Contracts.done) &&
          (!wizard.phases.vermarktungContracts?.displayPhase ||
            wizard.phases.vermarktungContracts.done)
      }
    ],
    [
      AssignmentType.Invoices,
      {
        displayPhase: (wizard) => wizard.phases.invoices.displayPhase,
        done: (wizard) =>
          wizard.phases.invoices.displayPhase && wizard.phases.invoices.done
      }
    ],
    [
      AssignmentType.Vollmachten,
      {
        displayPhase: (wizard) =>
          wizard.phases.msbauthority?.displayPhase ||
          wizard.phases.dataloadauthority?.displayPhase,
        done: (wizard) =>
          (!wizard.phases.msbauthority?.displayPhase ||
            wizard.phases.msbauthority.done) &&
          (!wizard.phases.dataloadauthority?.displayPhase ||
            wizard.phases.dataloadauthority.done)
      }
    ],
    [
      AssignmentType.OptiNode,
      {
        displayPhase: () => true,
        done: (wizard) => wizard.onboardingDone.onboardingDone
      }
    ]
  ]
);
